import { useWorkspace } from '../../shared/workspace/WorkspaceContext.jsx';
import LegacyPage from './legacy/LegacyPage.jsx';
import CampaignPage from './CampaignPage.jsx';

export default function DashboardPage({ page }) {
  const { moduleId, clientId, loading, err } = useWorkspace();
  if (loading || moduleId !== 'dashboard') return <main className="o-page"><p className="o-state" role="status">Loading workspaces…</p></main>;
  if (err) return <main className="o-page"><div className="o-state o-error" role="alert"><p>Unable to load workspaces. {err}</p><button className="o-btn" onClick={() => window.location.reload()}>Retry</button></div></main>;
  if (!clientId) return <main className="o-page"><p className="o-state">No workspace is available for Dashboard. Ask an administrator to enable Dashboard for your workspace and assign you access.</p></main>;
  const Component = page.id === 'paid-media' ? CampaignPage : LegacyPage;
  return <Component key={page.id + ':' + clientId} page={page} clientId={clientId} />;
}
